import { useSelector } from "react-redux";
import { useGetMerchantPermissions } from "../api/services/rolePermissionServices";
import Unauthorized from "../pages/Unauthorized";
import Loader from "./Loader";

const PermissionRoute = ({ permission, children }) => {
  const { user } = useSelector((state) => state.auth);
  const { data: merchantPermissions, isLoading } = useGetMerchantPermissions(user?.id);

  if (isLoading) return <Loader />;

  const permissions = merchantPermissions?.data?.permissions || [];
  const isAuthorized = permissions.some(
    (p) => p?.permissionName === permission
  );

  if (!isAuthorized) return <Unauthorized />;

  return children;
};

export default PermissionRoute;
